import { Pipe, PipeTransform, inject } from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
    name: 'zahPeriode',
    standalone: false
})
export class PeriodePipe implements PipeTransform {
  private datePipe = inject(DatePipe);

  transform(van: string, tot: string): string {
    if (van === tot) {
      return this.datePipe.transform(van, 'd MMMM yyyy');
    } else {
      return `${this.datePipe.transform(van, 'd MMMM yyyy')} - ${this.datePipe.transform(tot, 'd MMMM yyyy')}`;
    }
  }
}
